import React, { useState } from "react"
import ChevronRight from "../../assets/Images/icons/ChevronRight"
import Switch from "react-switch"
import Card from "../../components/Card"
import { SubHeadings, UserDetails, Labels } from "./component/common"
import DashboardContainer from "../Dashboard/DashboardContainer"
import Navbar from "../../components/Navbar"
import EditButton from "../../components/Buttons/EditButton"
import Modal from "../../components/Modal"
import CloseIcon from "../../assets/Icons/CloseIcon"
import AddEmailComponent from "../Home/component/AddEmailComponent"
import ChangePasswordForm from "../../components/Forms/ChangePasswordForm"
import DeleteAccountForm1 from "../../components/Forms/DeleteAccountForm1"
import DeleteAccountForm2 from "../../components/Forms/DeleteAccountForm2"
import Switch1 from "../../components/Switch/Switch1";
import "./account.css";
import Headings from "../../components/Texts/Headings"
const profileInfo = {
  name: "Vikram Das",
  phone: "+91 8422005522",
  email: "Vikram Das",
  address: "Pencil Point Designs, Nariman Point, Mumbai",
}

const MyAccount = () => {
  const [isSmsNotification, setIsSmsNotification] = useState(false);
  const [PasswordModal, setPasswordModal] = useState(false);
  const [DeleteAccountModal, setDeleteAccountModal] = useState(false);
  const [deleteFormToggle, setDeleteFormToggle] = useState(false);


  const PasswordToggle = () => {
    setPasswordModal((prev) => !prev)
  }
  const DeleteAccountToggle = () => {
    setDeleteAccountModal(!DeleteAccountModal);
  }
  const DeleteAccountCancelHandler = () => {
    DeleteAccountToggle();
    setDeleteFormToggle(false)
  }
  return (
    <>
      <Navbar />
      <DashboardContainer>
        <div className="max-w-[650px] p-6">
          <Headings
            text="My Account"
          />
          {/* Profile Information Section */}
          <SubHeadings title="Profile Information" />
          <Card className={"!p-[18px]"}>
            <UserDetails title="Name" value={profileInfo.name} />
            <UserDetails title="Phone Number" value={profileInfo.phone} />
            <div className="flex justify-between items-end">
              <UserDetails title="Email" value={profileInfo.email} />
              <EditButton
                title="Edit"
                variant="secondary"
                className="!border-primary font-[600] text-primary border-none shadow-none"
              />
            </div>
            <UserDetails title="Address" value={profileInfo.address} />
          </Card>
          {/* Security Section */}
          <SubHeadings title="SIGN IN & SECURITY" />
          <Card >
            <div className="">
              <button className=" w-full flex items-center justify-between p-2 hover:bg-gray-50 rounded-md transition-colors pb-[20px] "
                onClick={PasswordToggle}
              >
                <Labels title="Change Password" />
                <ChevronRight className="h-5 w-5 text-gray-400" />
              </button>
              <div className="bg-[#424952] bg-opacity-[30%] h-[0.5px]" />
              <button className="w-full flex items-center justify-between p-2 hover:bg-gray-50 rounded-md transition-colors pt-[20px]">
                <Labels title="Two Factor Authentication" />
                {/* <ChevronRight className="h-5 w-5 text-gray-400" /> */}
              </button>
            </div>
          </Card>

          {/* Notification Preferences */}
          <SubHeadings title="Notification Preferences" />
          <Card>
            <div className="flex items-center justify-between p-2">
              <Labels title="SMS Notifications" />
              <Switch1 Name='smsNotification' />

              {/* <Switch onChange={setIsSmsNotification} checked={isSmsNotification} /> */}
            </div>
            <p className="font-Apparat font-[600] text-[12px] leading-[17px] text-[#42495260]">With SMS notifications turned on, FastFin will send updates directly to your phone number, keeping you informed about loan details and offers.</p>
          </Card>

          <Card className={"mt-[28px]"}>
            <div className="flex items-center justify-between p-2">
              <Labels title="DND" />
              <Switch1 Name='dnd' />

              {/* <Switch onChange={setIsSmsNotification} checked={isSmsNotification} /> */}
            </div>
            <p className="font-Apparat font-[600] text-[12px] leading-[17px] text-[#42495260]">With DND activated, FastFin will only reach out to you on weekends, ensuring you have a peaceful workweek without interruptions.</p>
          </Card>

          {/* Language Settings */}
          <Card className="mt-[28px]">
            <button className="w-full flex items-center justify-between p-2 hover:bg-gray-50 rounded-md transition-colors">
              <Labels title="Language" />
              <Labels title="English" />
            </button>
          </Card>
          <Card className="mt-[28px]">
            <button className="w-full flex items-center justify-between p-2 hover:bg-gray-50 rounded-md transition-colors"
              onClick={DeleteAccountToggle}
            >
              <Labels title="Delete Account" />
            </button>
          </Card>
        </div>
      </DashboardContainer>
      <Modal visible={PasswordModal} onClose={PasswordToggle}>
        <Card>
          <div
            className="flex justify-end cursor-pointer"
            onClick={PasswordToggle}
          >
            <CloseIcon />
          </div>
          <ChangePasswordForm />
        </Card>
      </Modal>
      <Modal
        visible={DeleteAccountModal} onClose={DeleteAccountToggle}>
        <Card className="max-w-[618px]">
          <div
            className="flex justify-end cursor-pointer"
            onClick={DeleteAccountToggle}
          >
            <CloseIcon />
          </div>

          {deleteFormToggle ? <DeleteAccountForm2 confirmHandler={() => { }}
            cancelHandler={DeleteAccountCancelHandler}
          /> :
            <DeleteAccountForm1
              confirmHandler={() => setDeleteFormToggle(true)}
              cancelHandler={DeleteAccountCancelHandler}
            />
          }
        </Card>
      </Modal>
    </>
  )
}

export default MyAccount
